// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1ir3kb7n input::-ms-input-placeholder{opacity:1}\n._1ir3kb7n input::placeholder{opacity:1}\n._5ce61rpy input::-ms-input-placeholder{color:var(--ds-text-subtlest,#6b6e76)}\n._5ce61rpy input::placeholder{color:var(--ds-text-subtlest,#6b6e76)}\n._h5gq1rpy input:-ms-input-placeholder{color:var(--ds-text-subtlest,#6b6e76)}", ""]);
// Exports
module.exports = exports;
